import React, { Fragment } from 'react';
import { Prompt } from 'react-router'
import _ from 'lodash';
import TextFieldIcon from 'material-ui-icons/TextFields';
import ImageIcon from 'material-ui-icons/Image';
import Paper from 'material-ui/Paper/Paper';
import Wait from './../Wait';
import { CircularProgress } from 'material-ui/Progress';

import Page from './../Page';
import Experiment from './../../models/Experiment'

import {initLeftRailDragDrop, initElementDragDrop} from './ExperimentDragDropHelper';
import RightRail from './ExperimentRightRail';
import LeftRail from './ExperimentLeftRail';
import {ElementFactory} from './../ScreenElements/Elements';

import Table from './../Table';
import Tooltips from './../Tooltips';
import ClipboardJS from 'clipboard';

/*
TODO
Push to response endpoint
Preloading of images.
Handle small screens (word wrapping etc.)
Right Click on elements to send to front, forward, backward
Image place holder for images without a url
Disable scaling from the top or left.

For scaling
transform: scale(0.3);
transform-origin: center top;

*/

export default class Builder extends Page {

	static get mustBeResearcher(){ return true; }

	constructor(...args){
		super(...args);
 
		this.app.experiment = new Experiment(this.app, this);

		this.onKeyPress = this.onKeyPress.bind(this);
		// let localExperimentData = this.app.localStorage('experiment');
		// if(localExperimentData){
		// 	this.experiment.data = localExperimentData;
		// 	this.experiment.selectedScreens = [localExperimentData.screens.children[0]];
		// 	this.experiment.selectedElements = [localExperimentData.screens.children[0].elements[0]];
		// }
		
	}

	get experimentId(){
		return this.props.match.params.id;
	}

	get experiment(){
		return this.app.experiment;
	}

	componentDidMount(){
		this.app.builderForm.load({experimentId: this.experimentId});
		initLeftRailDragDrop(this.experiment);

		this.clipboard = new ClipboardJS('.copy-dataset',{
			text: this.experiment.copyDataSetToClipboard.bind(this.experiment)
		});
	}


	componentWillUnmount(){
		this.clipboard.destroy();
		window.onbeforeunload =  null;
	}

	onKeyPress(e){
		// Ignore inputs
		if(['INPUT','TEXTAREA','SELECT'].includes(e.target.tagName)){return;}

		if(this.experiment.currentScreen && this.experiment.selectedElements.length){
			if(['Delete', 'Backspace'].includes(e.key)){
				this.experiment.currentScreen.elements = _.without(this.experiment.currentScreen.elements, ...this.experiment.selectedElements);
				this.experiment.selectedElements = [];
				this.forceUpdate();
			}

			if(e.key === 'ArrowUp' && (e.ctrlKey || e.metaKey)){
				this.experiment.moveElements({position:'up', elements:this.experiment.selectedElements});
				e.preventDefault();
			}
			if(e.key === 'ArrowDown' && (e.ctrlKey || e.metaKey)){
				this.experiment.moveElements({position:'down', elements:this.experiment.selectedElements});
				e.preventDefault();
			}
			if(e.key === 'ArrowUp' && e.shiftKey){
				this.experiment.moveElements({position:'top', elements:this.experiment.selectedElements});
				e.preventDefault();
			}
			if(e.key === 'ArrowDown' && e.shiftKey){
				this.experiment.moveElements({position:'bottom', elements:this.experiment.selectedElements});
				e.preventDefault();
			}
		}

		if (e.key === 'c' && (e.metaKey || e.ctrlKey) && this.experiment.currentScreen) {
			this.experiment.copiedElements = _.cloneDeep(this.experiment.selectedElements);
		}

		if (e.key === 'v' && (e.metaKey || e.ctrlKey) && this.experiment.currentScreen && this.experiment.copiedElements) {
			this.experiment.currentScreen.elements = this.experiment.currentScreen.elements || [];
			this.experiment.currentScreen.elements.push(..._.cloneDeep(this.experiment.copiedElements));
			this.forceUpdate();
		}
	}

	render(){
		let experiment = this.experiment;
		let {isScreen, isGroup} = experiment.getViewStateFromCurrentScreen();
		let Screen = isScreen ? BuilderScreen : null;

		if(_.isEmpty(experiment.data)){
			return <Wait />;
		}

		let dataSet= experiment.currentDataSet;

		let hasChanges = experiment.hasChanges;
		window.onbeforeunload = () => experiment.hasChanges || null;
		if(hasChanges && !this.experiment.loading){
			experiment.debouncedSave();
		}

		return (
			<Fragment>
				<Prompt
					when={hasChanges}
					message="You have unsaved changes. Are you sure you want to leave?"
					/>
				<FileMenu app={this.app} experiment={experiment} hasChanges={hasChanges} id={this.props.match.params.id} />
				<section className="main" tabIndex="0" onKeyDown={this.onKeyPress}>
					<aside className="left-rail Builder-left-rail">
						<LeftRail screen={experiment.currentScreen} experiment={experiment} />
					</aside>
					<article  className="center-content Builder-center-content">		
						{isScreen && 
						<Fragment>
							<Toolbar experiment={experiment} app={this.app} />
							<Paper elevation={1} style={{width:`${experiment.data.width}px`, height:`${experiment.data.height}px`, position:'relative', margin:'20px auto 20px auto'}}>
								<Screen screen={experiment.currentScreen} experiment={experiment} />
								<div style={{fontSize:'12px', position:'absolute', bottom:'-25px', right:'-5px'}}>
									Screen Size <Tooltips id="screenSize" top={2}/>:
									<input
										className='screen-dimensions'
										type="text"
										placeholder="width"
										value={experiment.data.width || ''}
										onChange={ e => { experiment.data.width = e.currentTarget.value; experiment.forceUpdate(); } }
										/>
									x
									<input
										className='screen-dimensions'
										type="text"
										placeholder="height"
										value={experiment.data.height || ''}
										onChange={ e => { experiment.data.height = e.currentTarget.value; experiment.forceUpdate(); } }
										/>
								</div>
							</Paper>
							
						</Fragment>
						}

						{isGroup && dataSet &&
							<Dataset dataSet={dataSet} experiment={experiment}/>
						}
					</article>
					<aside className="right-rail Builder-right-rail">
						<RightRail screen={experiment.currentScreen} experiment={experiment} />
					</aside>
				</section>

				<div className="drag-file-drop-bg center-center MediaManager-drag-bg">Drop images, audio, and video files here.</div>
				<input
					multiple
					type='file'
					className='drag-file-input MediaManager-drag-input'
					onChange={this.app.mediaManager.uploadAssetFromManager.bind(this.app.mediaManager)} 
					accept="audio/*,video/*,image/*"
					/>

			</Fragment>
		);
	}
}

const FileMenu = (props) => (
	<div className="FileMenu">
		<a onClick={e=> props.experiment.showDetails()} className="experiment-name">{props.experiment.details.name}</a>
		<span className="experiment-changes-status">
			{ !!props.experiment.loading ?
			<span className="spinner">Saving... <CircularProgress  size={16} /></span>
			:
			<span>{props.hasChanges ? 'There are unsaved changes.' : 'All changes have been saved.' }</span>
			}
		</span>
		<a className='preview-link' onClick={e=> props.experiment.preview()}>Preview</a>
		<a onClick={e=> props.experiment.showDetails()}>Publish Details</a>
	</div>
);

const Toolbar = (props)=>(
	<div className="Builder-toolbar" style={{margin:'0px auto', padding:'2px 2px 2px 2px', display:'flex', justifyContent: 'space-between', width:'500px'}}>
		<span title="Text"><TextFieldIcon onClick={ e => props.experiment.addElement('text')} style={{width:'32px', height:'32px', margin:'0px 3px'}} /></span>
		<span title="Media"><ImageIcon onClick={ e => props.app.mediaManager.show()} style={{width:'32px', height:'32px', margin:'0px 3px'}} /></span>
		<ToolbarButton label="Button" type="button" experiment={props.experiment} />
		<ToolbarButton label="Textfield" type="textfield" experiment={props.experiment} />
		<ToolbarButton label="Multiple Choice" type="multiplechoice" experiment={props.experiment}/>
		<ToolbarButton label="Dropdown" type="dropdown" experiment={props.experiment} />
		<ToolbarButton label="Scale" type="scale" experiment={props.experiment} />
		<ToolbarButton label="Click Area" type="clickarea" experiment={props.experiment}/>
	</div>
)

const ToolbarButton = ({label, type, experiment}) => (
	<div onClick={ e => experiment.addElement(type)} style={{display:'block', margin:'3px 3px',}}>
		<img src={`/images/${type}.svg`} style={{height:'26px'}} alt={label} title={label} />
	</div>	
);

const Dataset = ({dataSet, experiment}) => (
	<Paper elevation={1} style={{width:'95%', padding:'15px', minHeight:'90%', margin:'10px auto 10px auto', maxWidth:'70vw', overflowX:'auto'}}>
		<h1 style={{marginTop:'0px', marginBottom:'15px', borderBottomWidth:'5px', fontSize:'20px', position:'relative'}}>
			Dataset <Tooltips id="datasets" />: {dataSet.id}
		</h1>
		<div style={{fontSize:'13px', position:'relative', top:'-12px', textAlign:'right'}}>
			<a onClick={experiment.downloadDataSet.bind(experiment, dataSet)}>Download CSV</a>&nbsp;&nbsp;&nbsp;&nbsp;
			<a className="copy-dataset">Copy To Clipboard</a>&nbsp;&nbsp;&nbsp;&nbsp;
			<a onClick={(e)=>{ document.querySelector('.datasetInput').click(); }}>Upload CSV (or drag in file)</a>&nbsp;&nbsp;&nbsp;&nbsp;
			<a onClick={(e)=>{ experiment.deleteDataSet(dataSet); }}>Delete</a>
		</div>
		<div className="drag-file-drop-bg center-center Dataset-drag-bg">Drop a CSV-like file here to replace Dataset: {dataSet.id}</div>
		<input type='file' className='datasetInput drag-file-input' onChange={experiment.uploadFile.bind(experiment)} />
		{ _.get(dataSet, 'rows[0]', []).indexOf('id') === -1 &&
			<div style={{borderRadius:'3px', margin:'10px 0', padding:'5px', backgroundColor:'var(--red)', fontSize:'13px', color:'white'}}>Error: One of the column headers needs to be <b>id</b>. Right-click in the dataset to add the needed column.</div>
		}
		<Table rows={dataSet.rows}></Table>
	</Paper>
);

class BuilderScreen extends React.Component {

	componentDidMount(){
		initElementDragDrop(this.props.experiment);
	}
	
	render(){
		return (
			<Fragment>
				<div style={{position:'relative', width:'100%', height:'100%'}}>
					<div style={{position:'absolute', left:0, right:0, top:0, bottom:0}} onClick={()=>{this.props.experiment.selectedElements = []; this.props.experiment.forceUpdate()}}></div>
					{(this.props.screen.elements || []).map( (element, i) => {
						return <ElementFactory element={element} key={`${i}_${element.id}`} experiment={this.props.experiment} builder /> 
					})}
					
				</div>
			</Fragment>
		);
	}
}





// WEBPACK FOOTER //
// ./src/components/Builder/Builder.js